import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { camelCase, get, isEmpty } from 'lodash'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import TrackingEvents from 'Services/Tracker/TrackingEvents'
import { createDataLayerItem, trackPurchase } from 'Services/Tracker/DataLayerTrackingEvents'
import Payment from '../Payment'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import storeCredit from 'GlobalStores/StoreCredit'
import States from 'Components/Elements/Forms/StatesModal/Country/AustraliaStates.json'
import storeFormAddress from 'GlobalStores/Checkout/StoreFormAddress'
import { FormatAPIs } from 'Services/FeelGreat/FormatAPIs'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import storeUser from 'GlobalStores/User/StoreUser'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeTaxInvoice from '../StoreTaxInvoice'
import storeFormat from 'GlobalStores/Format/StoreFormat'
import { objectToQueryString } from 'Helpers/GlobalHelpers'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'
import { PaymentAPIs } from '../PaymentServices/PaymentAPI'

class Thailand {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']

    autoAddressKeyToForm = {
        sub1: 'district',
        sub2: 'sub_district',
        city: 'province',
        zip: 'zip_code'
    }

    chainAddress = {
        isChainAddress: false,
        groupAddress: []
    }

    uuid = ''
    isAcceptPdpa = false
    selectShippingMethod = ''
    shippingMethod = 'delivery'
    paymentMethod = ''
    paymentErrors = []

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            password: ''
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: ''
        },
        shop: {
            uuid: this.GetUuid(),
            fullname: '',
            fullname_en: '',
            email: '',
            phone: '',
            password: '',
            zip: '',
            province: '',
            district: '',
            sub_district: '',
            house_number: ''
        }
    }

    formShop = {
        fullName: '',
        email: '',
        phone: '',
        street_address: '',
        city: '',
        state: '',
        zip_code: ''
    }

    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        fullname: '',
        fullname_en: '',
        email: '',
        phone: '',
        password: '',
        zip: '',
        province: '',
        district: '',
        sub_district: '',
        house_number: '',
        period: ''
    }

    ExcludedFieldsShippingIfCreateAccount = []

    ExcludedFieldsShipping = ['fullName', 'country']

    mapFormKeyToFormatKey = {
        fullNameNative: 'fullname',
        fullName: 'fullname_en',
        zip_code: 'zip',
        email: 'email',
        phone: 'phone',
        password: 'password',
        house_number: 'house_number',
        street: 'street',
        sub_district: 'sub_district',
        district: 'district',
        province: 'province',
        zip_code: 'zip'
    }

    ArrangeCreateCheckoutForm = [
        'fullNameNative',
        'fullName',
        'email',
        'phone',
        'password',
        'province',
        'district',
        'sub_district',
        'zip_code',
        'street',
        'house_number'
    ]

    PaymentStep = {
        prepare_data: 0,
        payment: 0,
        createOrder: 0,
        updateLog: 0 
    }

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        {
            caption: 'billing',
            link: '/checkout/payment',
            paramsRequire: true
        },
        {
            caption: 'purchase',
            link: '/checkout/review',
            paramsRequire: true
        }
    ]

    shippingMethods = [
        {
            id: 1,
            api_value: 'delivery',
            title: 'Delivery',
            dict_key: 'delivery',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'Credit card',
                    value: 'creditcard',
                    dict_key: 'ref_creditcard',
                    for_status: [],
                    icon: 'creditcard-icon'
                },
                {
                    id: 2,
                    title: 'QR payment',
                    value: 'qr_payment',
                    dict_key: 'qr_payment',
                    descripion: {
                        title: '',
                        dict_key: 'qr_payment'
                    },
                    for_status: [],
                    icon: 'pp-icon'
                }
            ]
        }
    ]

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping'
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: true,
            allowToUse: []
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]

    CustomShippingForms = [
        {
            key: 'fullNameNative',
            args: null,
            info: '',
            type: 'text',
            label: 'full_name_native',
            value: '',
            placeholder: ''
        },
        {
            key: 'email',
            args: null,
            info: '',
            type: 'text',
            label: 'email_address',
            value: '',
            placeholder: ''
        },
        {
            key: 'phone',
            args: {
                regx: '^[0-9]+$'
            },
            info: '',
            type: 'text',
            label: 'mobile_number',
            value: '',
            placeholder: ''
        },
        {
            key: 'country',
            args: {
                disabled: true
            },
            info: '',
            type: 'CountryBox',
            label: '',
            value: 'Thailand',
            placeholder: ''
        },
        {
            key: 'province',
            args: null,
            info: '',
            type: 'text',
            label: 'province',
            value: '',
            placeholder: ''
        },
        {
            key: 'district',
            args: null,
            info: '',
            type: 'text',
            label: 'district',
            value: '',
            placeholder: ''
        },
        {
            key: 'sub_district',
            args: null,
            info: '',
            type: 'text',
            label: 'sub district',
            value: '',
            placeholder: ''
        },
        {
            key: 'zip_code',
            args: null,
            info: '',
            type: 'zipCodeSearch',
            label: 'zip_code',
            value: '',
            placeholder: ''
        },
        {
            key: 'street',
            args: null,
            info: '',
            type: 'text',
            label: 'street',
            value: '',
            placeholder: ''
        },
        {
            key: 'house_number',
            args: null,
            info: '',
            type: 'text',
            label: 'house_number',
            value: '',
            placeholder: ''
        }
    ]
    addressList = {
        provinces: [],
        districts: {},
        subDistricts: {},
        zipCodes: {}
    }

    provinceList = []

    provinceId = ''
    districtId = ''
    subDistrictId = ''

    GetPaymentErrors() {
        return this.paymentErrors
    }

    StatesList() {
        let items = []
        States.map(raw => {
            items.push({
                text: raw.abbreviation,
                value: raw.abbreviation,
                html: `<span>${raw.name}</span>`
            })
        })
        return items
    }

    AddressOptionList(key) {
        let items = []
        States.map(raw => {
            items.push({
                text: raw,
                value: raw,
                html: `<span>${raw}</span>`
            })
        })
        return items
    }

    MapAutoAddressToForm(form, autoAddressData) {
        const swappedValuesAsKeys = ObjectHelpers.swapKeysAndValues(this.autoAddressKeyToForm)

        const swappedValuesAsKeysWithAssignKey = Object.fromEntries(
            Object.entries(swappedValuesAsKeys).map(([key, value]) => (key === 'zip_code' ? [key, value] : [key, ObjectHelpers.TowRomanAndNativeKey(value)]))
        )

        return form.map(item => {
            if (swappedValuesAsKeys[item.key]) {
                if (autoAddressData.data) {
                    item.value = autoAddressData.data[swappedValuesAsKeys[item.key]]
                }

                if (autoAddressData) {
                    item.value = autoAddressData[swappedValuesAsKeysWithAssignKey[item.key]]
                }
            }

            return item
        })
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    GetShippingMethod() {
        return this.shippingMethods.find(item => item.api_value === this.shippingMethod)
    }

    GetShippingMethods() {
        return this.shippingMethods
    }

    SetPaymentMethod(value) {
        runInAction(() => {
            this.paymentMethod = value
        })
    }

    GetPaymentMethod() {
        return this.paymentMethod
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    GetIsAcceptPdpa() {
        return this.isAcceptPdpa
    }

    SetIsAcceptPdpa(value) {
        this.isAcceptPdpa = value
    }

    async getPaymentData({ type, CreditCardEncrypted, Pay, overridedTotalPrice = 0, CreditCardAlias = '' }) {
        const totalPrice = get(storeFormat, 'data.ushop.u23.formatSummary.order_total', overridedTotalPrice)
        if (totalPrice === 0) return []

        let data = []

        const allowCreditEnable = get(StoreAuth, 'allowCredit.enable', false)

        if (type === 'qr') {
            const qrPayment = {
                method: 'qrPayment',
                amount: Number(totalPrice)
            }
            data.push(qrPayment)

            if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                const productCredit = storeCredit.GetCreditData()
                const useCredit = { method: 'eCredit', amount: productCredit.creditUsed }
                data.push(useCredit)
            }
        } else {
            // Prepare credit card data
            let creditCardData = {
                amount: Number(totalPrice)
            }

            if (!isEmpty(CreditCardEncrypted)) {
                creditCardData['method'] = camelCase(CreditCardEncrypted.method)
                creditCardData['payer'] = CreditCardEncrypted.methodDetails.payer
                creditCardData['creditCardNumber'] = CreditCardEncrypted.methodDetails.creditCardNumber
                creditCardData['creditCardSecurityCode'] = CreditCardEncrypted.methodDetails.creditCardSecurityCode
                creditCardData['creditCardExpires'] = CreditCardEncrypted.methodDetails.creditCardExpires

                data.push(creditCardData)
                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    const productCredit = storeCredit.GetCreditData()
                    const useCredit = { method: 'eCredit', amount: productCredit.creditUsed }
                    data.push(useCredit)
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted, useCredit]
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted]
                    }
                }
            }

            if (!isEmpty(CreditCardAlias)) {
                creditCardData['method'] = 'CreditCardAlias'
                creditCardData['type'] = 'AuthorizeAndCapture'
                creditCardData['methodDetails'] = {
                    alias: CreditCardAlias
                }

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    const productCredit = storeCredit.GetCreditData()
                    const useCredit = { method: 'eCredit', amount: productCredit.creditUsed }
                    data.push(useCredit)
                    creditCardData.amount = totalPrice - productCredit.creditUsed
                    data.push(creditCardData)
                    Pay.hydra.transactions = {
                        items: [creditCardData, useCredit]
                    }
                } else {
                    data.push(creditCardData)
                    Pay.hydra.transactions = {
                        items: [creditCardData]
                    }
                }
            }
        }

        return data
    }

    /**
     *
     * @param {*} uuid
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     */
    async SubmitPayment({ uuid, detailPage, CreditCardEncrypted, products, type = '', CreditCardAlias = '' }) {
        
        if (CreditCardAlias && CreditCardAlias.length > 0) {
            return this.SubmitPaymentAliasFlow(uuid, detailPage, CreditCardEncrypted, products, CreditCardAlias)
        } else {
            const Pay = new Payment(uuid, detailPage)
            try {
                ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //4111 1111 1111 1111
                    runInAction(() => {
                        StorePaymentStep.SetPaymentStep('prepare_data', 0)
                    })
                    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    storeCheckout.uuid = uuid

                    Pay.hydra = {
                        transaction: {}
                    }

                    if (type === 'qr') {
                        await Pay.PreparePaymentData()
                        const payer = get(Pay, 'hydra.customer.humanName["fullName@th"]') || get(Pay, 'hydra.customer.humanName.fullName', '')
                        const qrOrderPayload = {
                            ...toJS(Pay.hydraOrderAndSubscribe),
                            transactions: {
                                items: [{
                                    amount: 'this.terms.total',
                                    type: 'IOU',
                                    method: 'CreditCard',
                                    methodDetails: { payer, bankName: '2C2P-QR', branchName: '2C2P-PPQR' }
                                }]
                            }
                        }
                        const orderResponse = await PaymentAPIs.CreateOrderAndSubscriptions(qrOrderPayload, StoreAuth.GetToken())
                        Pay.orderData = get(orderResponse, 'data.data.order')
                        Pay.orderDataToUrl = `${ServerEnv.Hydra()}/customers/me/ordersAndSubscriptions?async=false`
                        Pay.orderDataHeader = orderResponse.headers
                        Pay.autoshipNumber = get(orderResponse, 'data.data.autoOrder.id.unicity')
                        Pay.hydra.transactions = qrOrderPayload.transactions
                        storeCheckout.qrPay = Pay // QRPaymentPage fires UpdateToLog from this when the QR poll returns success
                        const iouReceipt = get(Pay.orderData, 'successfulPayments[0].methodDetails.iouReceipt')
                            || get(Pay.orderData, 'successfulPayments.methodDetails.iouReceipt')
                            || get(Pay.orderData, 'transactions.items[0].methodDetails.iouReceipt')
                        runInAction(() => {
                            StorePaymentStep.SetPaymentStep('createOrder', 1)
                            StorePaymentStep.SetPaymentStep('payment', 1)
                            setTimeout(() => { StorePaymentStep.PaymentDone = true }, 1500)
                        })
                        return {
                            success: true,
                            payment_ref: Pay.paymentId,
                            qr_image_url: get(iouReceipt, 'url'),
                            transactionStatusInquiry: get(iouReceipt, 'transactionStatusInquiry'),
                            ...(detailPage.type === 'enroll' && { order_type: detailPage.type })
                        }
                    }

                    const responsePreparePayment = await Pay.PreparePaymentData()
                    runInAction(() => {
                        StorePaymentStep.SetPaymentStep('prepare_data', 1)
                        StorePaymentStep.SetPaymentStep('payment', 0)
                    })

                    const allowCreditEnable = StoreAuth.IsAllowCredit()

                    const creditCardData = {
                        ...CreditCardEncrypted,
                        type: 'IOU',
                        methodDetails: {
                            ...CreditCardEncrypted.methodDetails,
                            bankName: '2C2P'
                        }
                    }

                    if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                        Pay.hydra.transactions = {
                            items: [creditCardData, storeCredit.ProductCreditUsed()]
                        }
                    } else {
                        Pay.hydra.transactions = {
                            items: [creditCardData]
                        }
                    }

                    const formatTaxInvoiceHydra = get(storeFormat, 'data.ushop.u23.formatTaxInvoiceHydra', {})
                    if (!StoreAuth.isAuthorized && storeTaxInvoice.requestTaxInvoice) {
                        const customerForm = { ...Pay.hydra.customer }
                        delete customerForm['humanName']
                        delete customerForm['mainAddress']
                        await storeUser.SetCustomerHydraPayload({
                            ...customerForm,
                            ...formatTaxInvoiceHydra,
                            shipToName: Pay.hydra.shipToName,
                            shipToAddress: Pay.hydra.shipToAddress
                        })
                    } else {
                        await storeUser.SetCustomerHydraPayload(Pay.hydra.customer)
                    }

                    const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)

                    if (!(await this.CheckCreditCardAliasesBeforeOrder())) {
                        return { success: false }
                    }

                    await Pay.PostToHydraWithCreateAutoShip()
                    runInAction(() => { StorePaymentStep.SetPaymentStep('payment', 1) })

                    const challengeURL = Pay.orderData?.transactions?.items?.find(item => item.methodDetails?.challengeURL)?.methodDetails?.challengeURL
                    if (challengeURL) {
                        // log before the OTP redirect, without payment_status — the success page sends it via hydra-log-by-order
                        await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'challenge', true)
                        window.location.href = challengeURL
                        return { success: true }
                    }

                    const orderTotal = Pay.orderData?.terms?.total
                    if (orderTotal < 3000) {
                        // if order total less than 3000 set error and return false ,and send log as success normally - BE will process further, can see details on clickup
                        // https://app.clickup.com/t/55477/USHOP-2312
                        await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'success')
                        runInAction(() => {
                            StorePaymentStep.SetPaymentStep('payment', -1)
                            storeCheckout.paymentErrors = ['try_again']
                        })
                        return { success: false }
                    }

                    Pay.SendEmailV4()
                    Pay.SendSms()

                    await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'success')

                    const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
                    console.log('call GetPaymentDetail', responsePaymentDetail)
                    runInAction(() => {
                        StorePaymentStep.PaymentDone = true
                    })

                    try {
                        TrackingEvents.PurchaseEvent({
                            transaction_id: responsePreparePayment.data.data.payment_id,
                            value: Pay.ushop.total_price,
                            currency: 'THB',
                            category: Pay.ushop.shipment_purchas_option,
                            items: products
                        })
                        trackPurchase({
                            transaction_id: responsePreparePayment.data.data.payment_id,
                            currency: 'THB',
                            value: Pay.ushop.total_price,
                            items: Array.isArray(products) ? products.map(item => createDataLayerItem(item)) : []
                        })
                    } catch (e) {
                        console.error('TrackingEvents.PurchaseEvent', e)
                    }

                    return {
                        success: true,
                        payment_id: responsePreparePayment.data.data.payment_id,
                        order_number: responsePaymentDetail.data.order_number,
                        ...(detailPage.type === 'enroll' && { order_type: detailPage.type })
                    }

                } catch (error) {
                    console.error(error)
                    const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
                    Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, true, 'error')
                    runInAction(() => {
                        if (StorePaymentStep.GetPaymentSteps().createOrder === -1) {
                            StorePaymentStep.SetPaymentStep('payment', -1)
                        }
                        StorePaymentStep.PaymentDone = true
                    })
                    return { success: false }
                }

        }
    }

    async SubmitPaymentAliasFlow(uuid, detailPage, CreditCardEncrypted, products, CreditCardAlias) {
        const Pay = new Payment(uuid, detailPage)
        console.log('SubmitPaymentAliasFlow')

        try {
            const responsePreparePayment = await Pay.PreparePaymentData()
            const allowCreditEnable = StoreAuth.IsAllowCredit()
            if (CreditCardAlias && CreditCardAlias.length > 0) {
                const creditCardAliasData = {
                    type: 'IOU',
                    method: 'CreditCardAlias',
                    methodDetails: {
                        alias: CreditCardAlias,
                        creditCardSecurityCode: storeCheckout.cardAliasCvv,
                        bankName: '2C2P',
                        browser: {
                            // EMV 3DS 2.0 browser information, required by 2C2P
                            colorDepth: window.screen.colorDepth,
                            javaEnabled: typeof navigator.javaEnabled === 'function' ? navigator.javaEnabled() : false,
                            javaScriptEnabled: true,
                            language: navigator.language,
                            screenHeight: window.screen.height,
                            screenWidth: window.screen.width,
                            timeZone: new Date().getTimezoneOffset(),
                            userAgent: navigator.userAgent
                        }
                    },
                    amount: 'this.terms.total'
                }

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    let amount = Number(Pay.ushop.total_price) - Number(storeCredit.ProductCreditUsed().amount)
                    if (amount > 0) {
                        creditCardAliasData.amount = Number(amount)
                        Pay.hydra.transactions = {
                            items: [creditCardAliasData, storeCredit.ProductCreditUsed()]
                        }
                    } else {
                        Pay.hydra.transactions = {
                            items: [storeCredit.ProductCreditUsed()]
                        }
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [creditCardAliasData]
                    }
                }
            } else {
                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted, storeCredit.ProductCreditUsed()]
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted]
                    }
                }
            }

            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)

            if (!(await this.CheckCreditCardAliasesBeforeOrder(CreditCardAlias))) {
                return { success: false }
            }

            await Pay.PostToHydraWithCreateAutoShip()

            // 3DS challenge (OTP) — after the redirect, the success page fires hydra-log-by-order
            const challengeURL = Pay.orderData?.transactions?.items?.find(item => item.methodDetails?.challengeURL)?.methodDetails?.challengeURL
            if (challengeURL) {
                // log before the OTP redirect, without payment_status — the success page sends it via hydra-log-by-order
                await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'challenge', true)
                window.location.href = challengeURL
                return { success: true }
            }


            const orderTotal = Pay.orderData?.terms?.total

            // if order total less than 3000 set error and return false ,and send log as success normally - BE will process further, can see details on clickup
            // https://app.clickup.com/t/55477/USHOP-2312
            if (orderTotal < 3000) {
                await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'success')

                runInAction(() => {
                    // StorePaymentStep.SetPaymentStep('prepare_data', 1)
                    StorePaymentStep.SetPaymentStep('payment', -1)
                    storeCheckout.paymentErrors = ['try_again']
                })
                return { success: false }
            }

            Pay.SendEmailV4()
            Pay.SendSms()

            if (hasSubscribe) {
                await Pay.UpdateToLog(Pay.hydra.transactions, 1, false, 'success')
            } else {
                await Pay.UpdateToLog(Pay.hydra.transactions, 0, false, 'success')
            }

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            try {
                TrackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'AUD',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
                trackPurchase({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    currency: 'THB',
                    value: Pay.ushop.total_price,
                    items: Array.isArray(products) ? products.map(item => createDataLayerItem(item)) : []
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }
            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, true, 'error')
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false }
        }
    }

    async CheckCreditCardAliasesBeforeOrder(CreditCardAlias = '') {
        try {
            const responseAliases = await FeelGreatAPI.Creditcardaliases(StoreAuth.GetToken(), storeUser.CustomerData().Country())
            if (!CreditCardAlias) return true

            const aliasList = get(responseAliases, 'data.items') || get(responseAliases, 'data') || []
            const aliasStillExists =
                Array.isArray(aliasList) &&
                aliasList.some(
                    item =>
                        get(item, 'methodDetails.alias') === CreditCardAlias ||
                        get(item, 'methodDetails.creditCardNumber') === CreditCardAlias ||
                        get(item, 'methodDetails.creditCardNumberMasked') === CreditCardAlias
                )

            if (aliasStillExists) return true

            runInAction(() => {
                StorePaymentStep.SetPaymentStep('payment', -1)
                storeCheckout.paymentErrors = ['try_again']
            })
            return false
        } catch (e) {
            console.error('CheckCreditCardAliasesBeforeOrder: card-alias recheck failed, proceeding', e)
            return true
        }
    }

    async CreateAccount(uuid, shippingForm, referral) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress)
            const returnShippingAddress = {}

            shippingForm.map(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }
                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            delete forms.country

            forms.shipment_packs = JSON.stringify(storeCheckout.cart)
            forms.uuid = uuid

            if (!storeCheckout.period) {
                const periodResponse = await FeelGreatAPI.GetPeriod('TH')
                forms.period = periodResponse.data.entryPeriod
                storeCheckout.period = periodResponse.data.entryPeriod
            } else {
                forms.period = storeCheckout.period
            }

            //Only Thailand
            forms['is_new_ba'] = true

            const queryStrings = objectToQueryString({
                dev: ServerEnv.ENV === 'DEV' ? '1' : undefined,
                isSkipCheckPassword: storeFeelGreat.passwordSettings.isUseComplexPassword ? '1' : undefined,
                createAccountBody: '1',
                isValidateVirginAddress: '1'
            })

            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/THA/feelGreat/createAccount${queryStrings}`
            const response = await axios.post(url, forms)

            const result = {}

            if (response?.data?.success === false) {
                result.success = false
                result.data = response.data
                result.forms = forms
            } else {
                result.success = true
                result.data = response.data
                result.forms = forms
            }

            return result
        } catch (e) {
            console.error(e)
            let error = get(e, 'response.data.error.body.error.message', null)

            return {
                success: false,
                data: {
                    axiosError: error
                }
            }
        }
    }

    async FetchCityList() {
        try {
            const data = await FeelGreatAPI.GetCityList()
            runInAction(() => {
                this.provinceList = data.data.data
            })
        } catch (error) {
            console.error(error)
        }
    }

    async FetchAddressList() {
        try {
            const response = await FeelGreatAPI.GetTHAAddressJSON()

            runInAction(() => {
                const addressList = response.data

                this.addressList = {
                    provinces: addressList.provinces || [],
                    districts: addressList.districts || {},
                    subDistricts: addressList.sub_districts || {},
                    zipCodes: addressList.zip_codes || {}
                }
            })
        } catch (error) {
            console.error('DEBUG FetchAddressList error', error.message)

            this.addressList = {
                provinces: [],
                districts: {},
                subDistricts: {},
                zipCodes: {}
            }
        }
    }

    GetDistrictList() {
        return this.addressList.districts[this.provinceId] || []
    }

    GetSubDistrictList() {
        return this.addressList.subDistricts[this.districtId] || []
    }

    GetZipCodeList() {
        return this.addressList.zipCodes[this.subDistrictId] || []
    }

    SetProvinceId(provinceId) {
        this.provinceId = provinceId
    }

    GetProvinceId() {
        return this.provinceId
    }

    SetDistrictId(districtId) {
        this.districtId = districtId
    }

    GetDistrictId() {
        return this.districtId
    }

    SetSubDistrictId(subDistrictId) {
        this.subDistrictId = subDistrictId
    }

    GetSubDistrictId() {
        return this.subDistrictId
    }

    HandleSaveAddressHistory(formData) {
        const province = this.addressList?.provinces.find(item => String(item.province_id) === String(this.provinceId)) || {}

        const provinceName = province.name_native || formData.province

        const districtByProvince = this.addressList?.districts[this.provinceId] || []

        const district = districtByProvince.find(item => String(item.district_id) === String(this.districtId)) || {}

        const districtName = district.name_native || formData.district

        const subDistrictByDistrict = this.addressList?.subDistricts[this.districtId] || []

        const subDistrict = subDistrictByDistrict.find(item => String(item.sub_district_id) === String(this.subDistrictId)) || {}

        const subDistrictName = subDistrict.name_native || formData.sub_district

        return {
            house_number: formData.house_number || '',
            street: formData.street || '',
            sub_district: subDistrictName,
            district: districtName,
            province: provinceName,
            zip: formData.zip,
            fullname: formData.fullname
        }
    }

    async ContinueToPayment() {
        const response = {
            success: false
        }
        try {
            if (StoreAuth.IsAuthorized()) {
                const formatType = 'shop'
                storeCheckout.CheckOutInstance().FormToFormat(formatType, storeCheckout.GetShippingForm())

                const data = storeCheckout.InitializeFormShippingData(formatType)

                // console.log('THA data', data)

                data.uuid = storeCheckout.GetUuid()
                delete data.period
                data.type = 'shop'

                if (storeCheckout.shippingMethod) {
                    data.shipment_options = storeCheckout.shippingMethod.api_value
                }

                if (StoreAuth.IsAuthorized()) {
                    data['ba_status'] = StoreAuth.userStatus
                    data['login_id'] = StoreAuth.GetId().toString()
                    data['login_name'] = storeUser.CustomerData().GetNativeName(storeUser.userData.humanName, 'fullName')
                    data['login_name_native'] = storeUser.CustomerData().GetNativeName(storeUser.userData.humanName, 'nativeName')
                    data['token'] = StoreAuth.GetToken()

                    delete data?.country

                    if (data.confirm_password) {
                        delete data.confirm_password
                    }
                }

                data.shipment_packs = JSON.stringify(storeCheckout.cart)
                data['tax_invoice'] = storeTaxInvoice.requestTaxInvoice ? 1 : 0
                data['selectAddressHistory'] = storeFormAddress.typeFormAddress

                if (storeFormAddress.typeFormAddress === 'addressHistory') {
                    data['fullName'] = get(storeFormAddress.GetDataMainAddress(), 'ushopShipToName', '')
                    data['shipToAddress'] = get(storeFormAddress.GetDataMainAddress(), 'shipToAddress', null)
                }

                if (storeFormAddress.typeFormAddress === 'new') {
                    data['shipToAddress'] = storeFormAddress.FormatShipToAddress(data)
                }

                const queryStringOptions = {
                    isValidateVirginAddress: '1'
                }

                const updateResponse = await FormatAPIs.putHotFormatV2(data, StoreCountry.Country3(), false, queryStringOptions)

                if (updateResponse.data.success === false) {
                    response.success = false
                    runInAction(() => {
                        storeCheckout.checkoutErrors = [...updateResponse.data.Message_v2, `#${updateResponse.data.error_ref}`]
                    })
                } else {
                    if (storeFormAddress.typeFormAddress === 'new') {
                        if (storeFormAddress.IsLegitAddressHistory()) {
                            await storeFormAddress.SaveAddressHistory(this.HandleSaveAddressHistory(data))

                            const addressHistoryResponse = await FeelGreatAPI.GetAddressHistory()

                            const { data: addressHistoryData } = addressHistoryResponse

                            if (addressHistoryData) {
                                if (addressHistoryData?.items?.length > 0) {
                                    storeFormAddress.displayMainAddress = addressHistoryData.items[0]
                                    storeFormAddress.SetAddressHistorySelected(addressHistoryData.items[0])

                                    addressHistoryData.items?.push(addressHistoryData.mainAddress)

                                    const filterItemsByCountry = addressHistoryData.items?.filter(
                                        item => item.shipToAddress?.country === storeCountry.Country2()
                                    )

                                    runInAction(() => {
                                        if (filterItemsByCountry.length === 0) {
                                            storeFormAddress.typeFormAddress = 'new'
                                        } else {
                                            storeFormAddress.listAddress = filterItemsByCountry
                                        }
                                    })
                                }
                            }
                        }
                    }

                    storeCheckout.checkoutErrors = []
                    response.success = true
                }
            }
        } catch (e) {
            console.log('Thailand ContinueToPayment error', e)
            if (StoreAuth.IsAuthorized()) {
                if (!StoreAuth.GetId()) {
                    window.location.reload()
                }
            } else {
                response.success = false
                runInAction(() => (storeCheckout.dataReady = true))
                console.log(e)
            }
        }
        return response
    }

    pageConfig = {
        signUp: {
            disable: true
        }
    }

    GetPageConfig() {
        return this.pageConfig
    }

    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        // this.FetchCityList()
        this.FetchAddressList()
        makeAutoObservable(this)
    }
}

export default Thailand
